import type { RouteObject } from 'react-router-dom'
import { useRoutes } from 'react-router-dom'
import React, { Suspense } from 'react'
import Layout from '@/components/Layout'

const Home = React.lazy(() => import('@/pages/Home'))
const About = React.lazy(() => import('@/pages/About'))
const Contact = React.lazy(() => import('@/pages/Contact'))

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="flex flex-col items-center gap-4">
      <div className="w-10 h-10 border-3 border-[#E2E8F0] border-t-[#1A6B4E] rounded-full animate-spin" />
    </div>
  </div>
)

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Suspense fallback={<Loading />}><Home /></Suspense> },
      { path: 'about', element: <Suspense fallback={<Loading />}><About /></Suspense> },
      { path: 'contact', element: <Suspense fallback={<Loading />}><Contact /></Suspense> },
    ],
  },
]

function App() {
  return useRoutes(routes)
}

export default App
